import React, { useRef } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { FiPaperclip } from 'react-icons/fi';
import { ATTACHMENT_LIMITS } from '../../libs/fileAttachmentUtils';

export const AttachButton = ({ 
  onFilesSelected, 
  disabled = false,
  filesCount = 0 
}) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length > 0) {
      onFilesSelected(files);
    }
    // Clear the input so the same file can be selected again
    event.target.value = '';
  };

  const remainingSlots = ATTACHMENT_LIMITS.maxFiles - filesCount;
  const isDisabled = disabled || remainingSlots <= 0;

  const getTooltipText = () => {
    if(disabled) {
      return "Coming soon";
    }
    else if (remainingSlots <= 0) {
      return `Maximum ${ATTACHMENT_LIMITS.maxFiles} attachments allowed`;
    }
    return `Add files (${remainingSlots} remaining)`;
  };

  return (
    <>
      <Tooltip title={getTooltipText()}>
        <span>
          <IconButton
            onClick={handleClick}
            disabled={isDisabled}
            size="small"
            sx={{
              color: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'white'
              },
              '&.Mui-disabled': {
                color: 'grey.400'
              }
            }}
          >
            <FiPaperclip size={18} />
          </IconButton>
        </span>
      </Tooltip>
      
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/png,image/jpeg,image/gif,image/webp,.pdf,.csv,.xlsx,.txt,.py,.json,.md"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
};